module.exports = __webpack_public_path__ + "img/gk.7cf7ad3e.svg";